module.exports = __webpack_public_path__ + "img/event-section.ee806012.svg";